<app-header-logged></app-header-logged>
<div class="payment-success-modal">
  <div class="payment-status">
    <img class="payment-success" src="assets/images/payment-modal-success.svg">
  </div>
  <div class="payment-message">
    <span class="payment-message-main">Thank you!</span>
    <span class="payment-message-secondary">{{response}}</span>
  </div>
</div>
